import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import PopOver from "../../pop-over/PopOver";
import CalendarInput from "../../form/calendar-input/CalendarInput";

const propTypes = {
	// onChange callback (field, value) => do whatever you want
	onChange: PropTypes.func.isRequired,

	// the value to show
	value: PropTypes.shape({
		from: PropTypes.string.isRequired,
		to: PropTypes.string.isRequired,
	}).isRequired,
};

const defaultProps = {};

export default class FilterDetailDateRange extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			// show the date range picker popover - it has its own buttons so it needs to tell the popover to close
			showDateRangePopOver: false,
			dateRange: {from: '', to: ''},
		};

		this.onChange = this.onChange.bind(this);
		this.changeFilterPopOverShown = this.changeFilterPopOverShown.bind(this);
		this.dateRangeFilterChange = this.dateRangeFilterChange.bind(this);
	}

	onChange(field, value) {
		const newValue = clone(this.props.value);
		newValue[field] = value;
		this.props.onChange(field, newValue);
	}

	changeFilterPopOverShown(popOverShown) {
		const newState = {
			showDateRangePopOver: popOverShown,
		};
		if (popOverShown) {
			newState.dateRange = clone(this.props.value);
		}
		this.setState(newState);
	}

	dateRangeFilterChange(field, value) {
		const newDateRange = clone(this.state.dateRange);
		newDateRange[field] = value;
		this.setState({dateRange: newDateRange});
	}

	render() {
		const anchor = (this.props.value.from || this.props.value.to) ? (
				<React.Fragment>
					<div>{this.props.value.from || ' '}</div>
					<div>{this.props.value.to || ' '}</div>
				</React.Fragment>
			) : <input type="text" placeholder="Filter" value="" readOnly={true} disabled={true}/>;


		return (
			<PopOver
				anchor={anchor}
				className="table-date-filter"
				classNamePopup="elevation--z4"
				dismissible={false}
				mode={PopOver.MODE.CLICK}
				onPopoverToggle={this.changeFilterPopOverShown}
				showPopup={this.state.showDateRangePopOver}
			>
				<div className="date-filter-title">Date Range</div>
				<div><CalendarInput label="From" field="from" onChange={this.dateRangeFilterChange} value={this.state.dateRange.from}/></div>
				<div><CalendarInput label="To" field="to" onChange={this.dateRangeFilterChange} value={this.state.dateRange.to}/></div>
				<div className="date-filter-buttons">
					<button
						onClick={() => this.changeFilterPopOverShown(false)}
						type="button"
					>Cancel</button>
					<button
						onClick={() => {
							this.setState({dateRange: {from: '', to: ''}});
							this.changeFilterPopOverShown(false);
							this.props.onChange(undefined, {from: '', to: ''});
						}}
						type="button"
					>Clear</button>
					<button
						onClick={() => {
							this.props.onChange(undefined, this.state.dateRange);
							this.changeFilterPopOverShown(false);
						}}
						type="button"
					>Apply</button>
				</div>
			</PopOver>
		);
	}
}

FilterDetailDateRange.defaultProps = defaultProps;
FilterDetailDateRange.propTypes = propTypes;